export const AUTH_FAILED_TEXT = 'Пользователь не авторизован';
export const AUTH_BY_CODE_ERROR = 'Ошибка авторизации code';
export const AUTH_BY_TRACK_ERROR = 'Ошибка авторизации trackId';
export const AUTH_TIMEOUT_ERROR = 'Таймаут авторизации';
export const AUTH_SESSION_ENDED_ERROR = 'Сессия завершена';
export const AUTH_STALE_TOKEN_ERROR = 'Токен не обновился';

/**
 * Ошибки, которые не показываем пользователю: авторизация либо отменена им
 * самим, либо уже обработана редиректом/разлогином. Важно, что это именно
 * реджект, а не зависший промис — вызывающий код должен дойти до finally
 * и снять лоадеры.
 */
export const AUTH_SILENT_ERRORS = [
	AUTH_BY_CODE_ERROR,
	AUTH_BY_TRACK_ERROR,
	AUTH_TIMEOUT_ERROR,
	AUTH_SESSION_ENDED_ERROR,
	AUTH_STALE_TOKEN_ERROR
];
